module.exports = __webpack_public_path__ + "img/YXLSXT_IOS.3d0e225d.png";